export const changeTrackingComponentFragment = `
fragment changeTrackingFields on ChangeTrackComponent {
  current {
    guid
    hash
  }
  previous {
    guid
    hash
  }
  serverSaveTime
  save {
    uid
    time
  }
}`;

export const rationsWithBulkFactorQuery = `
query Rations($guid: String!) {
  Rations(guid: $guid) {
    typename
    guid
    name
    description
    rationMinMix
    jaylorMinMix
    useJobWeightBool
    minMixTime
    active
    challengePercentage
    bulkFactor
    rationCost {
      typename
      metadata {
        userName
        userId
        userEmail
        feedlot
        gcp
        location
      }
      guid
      history {
        auto
        value
        per
        since
        unit
      }
      changeTracking {
        current {
          guid
          hash
        }
        previous {
          guid
          hash
        }
        serverSaveTime
        save {
          uid
          time
        }
      }
    }
    dryMatterFactor {
      typename
      guid
      componentGuid
      dryMatterFactor
      history {
        value
        since
      }
    }
    rationComponents {
      typename
      guid
      code
      sequence
      percentage
      toleranceOver
      toleranceUnder
      toleranceAbort
      componentMaterial {
        typename
        guid
        code
        name
        description
        manuallyLoaded
        active
      }
    }
  }
}`;
